'use client'

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react'
import { cn } from '@/src/utils/styles'

function Collapsible({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot='collapsible' {...props} />
}

interface CollapsibleTriggerProps
  extends React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger> {
  showIcon?: boolean
}
function CollapsibleTrigger({
  children,
  className,
  showIcon = true,
  ...props
}: CollapsibleTriggerProps) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      className={cn('group/collapsible-trigger w-full', className)}
      data-slot='collapsible-trigger'
      {...props}
    >
      {showIcon ? (
        <div className='flex justify-between items-center gap-2'>
          {children}
          <ChevronsUpDown className='size-5 text-tertiary hidden group-data-closed/collapsible-trigger:block' />
          <ChevronsDownUp className='size-5 text-tertiary hidden group-data-open/collapsible-trigger:block' />
        </div>
      ) : (
        children
      )}
    </CollapsiblePrimitive.CollapsibleTrigger>
  )
}

function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot='collapsible-content'
      {...props}
    />
  )
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
